<template>
  <i data-lucide="clock" class="lucide-icon"></i>
</template>

<script>
export default {
  name: 'IconClock',
  mounted() {
    // Initialize Lucide icons after component mounts
    if (window.lucide) {
      window.lucide.createIcons()
    }
  },
}
</script>

<style scoped>
.lucide-icon {
  width: 24px;
  height: 24px;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
  display: inline-block;
}
</style>
